import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { WebhookStatus } from "../setting/developer/types";

export interface TeamWebhook {
  _id: string;
  externalId: string | null;
  topic: string;
  url: string;
  bearerToken: string;
  kind: string;
  status?: WebhookStatus;
}

/**
 * GET /team-webhooks
 */
export async function getTeamWebhooks(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal },
): Promise<TeamWebhook[]> {
  const response = await client.client.get("team-webhooks", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}

/**
 * GET /team-webhooks
 */
export async function setTeamWebhooks(
  client: RedoMerchantClient,
  { webhooks, signal }: { webhooks: TeamWebhook[]; signal?: AbortSignal },
): Promise<void> {
  const response = await client.client.put("team-webhooks", webhooks, {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}
